// src/lib/types.ts
// Bilingual content shapes. Text fields have En + Fr variants; both required on save.
// Legacy single-language fields kept optional for backward compatibility with old rows.

export interface Session {
  id: string;
  TitleEn: string;
  TitleFr: string;
  DescriptionEn?: string;
  DescriptionFr?: string;
  JoinUrl?: string;
  StartTime: string;
  EndTime: string;
  Room?: string;
  Track?: 'Keynote' | 'Technical' | 'Business' | 'Workshop';
  SpeakerIds?: string;
  Capacity?: number;
  Tags?: string;
  Published: boolean;
  // legacy
  Title?: string;
  Description?: string;
}

export interface Speaker {
  id: string;
  TitleEn: string; // name (usually same across languages, but kept bilingual for titles/roles)
  TitleFr: string;
  JobTitleEn?: string;
  JobTitleFr?: string;
  Company?: string;
  BioEn?: string;
  BioFr?: string;
  PhotoUrl?: string;
  LinkedInUrl?: string;
  Order?: number;
  RowBreak?: boolean;
  Published: boolean;
  // legacy
  Title?: string;
  JobTitle?: string;
  Bio?: string;
}

export interface Sponsor {
  id: string;
  TitleEn: string;
  TitleFr: string;
  Tier: 'Platinum' | 'Gold' | 'Silver' | 'Bronze';
  LogoUrl: string;
  Website?: string;
  BoothNumber?: string;
  DescriptionEn?: string;
  DescriptionFr?: string;
  Published: boolean;
  // legacy
  Title?: string;
  Description?: string;
}

export interface RSVP {
  id: string;
  SessionId: string;
  SessionTitle?: string;
  UserEmail: string;
  UserName: string;
  Status: 'confirmed' | 'cancelled' | 'waitlist';
  DietaryRestrictions?: string;
  AccessibilityNeeds?: string;
  SubmittedAt: string;
}

export interface ContentBundle {
  sessions: Session[];
  speakers: Speaker[];
  sponsors: Sponsor[];
}

export interface ClientPrincipal {
  userId: string;
  userDetails: string;
  identityProvider: string;
  userRoles: string[];
}

// Helper: pick the right language variant with fallback
export function pick(lang: 'en' | 'fr', en?: string, fr?: string, legacy?: string): string {
  if (lang === 'fr') return fr || en || legacy || '';
  return en || legacy || fr || '';
}
